export const hasChangedValues = (pairs: [unknown, unknown][]) =>
  pairs.some(([oldValue, newValue]) => oldValue !== newValue)
